import { AppLoader } from "./loader/appLoader";
import { State } from "../types";

export const state: State = {
  map: null,
  loader: new AppLoader(),
  isFirstLoad: true,
  savedMapState: null,
  lastModalArgs: null,
  isModalOpen: false,
  restoreModal: false,
  autoOpenGallery: false,
  swiperInstance: null,
};
